import React from 'react';
import { TAPPrivacyPolicyUsuarios } from '../../components';

const PrivacyPolicyUsuarios = () => {
  return (
    <>
    <TAPPrivacyPolicyUsuarios />
    </>
  )
}

export default PrivacyPolicyUsuarios
